import { checkUser } from "@shared/actions/user";
import { poller } from "@shared/services";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

const DEFAULT_POLLING_USER_INTERVAL = 25_000;

export function usePollUserService() {
  const dispatch = useDispatch();

  const fetchUser = useCallback(async () => {
    dispatch(checkUser());
  }, []);

  useEffect(() => {
    const { disposeCallback } = poller.poll(
      fetchUser,
      DEFAULT_POLLING_USER_INTERVAL
    );
    return () => disposeCallback?.();
  }, []);
}
